module.exports = __webpack_public_path__ + "img/logo.d07a7f24.png";